import { Select, SelectProps } from 'antd';
import styled from 'styled-components';

export interface PropsSelect<T> extends SelectProps<T> {}

export default styled(Select)<PropsSelect<{}>>`
  font-size: 14px;
  letter-spacing: 0;
  line-height: 21px;
  border: 1px solid #e6e6e6;
  border-radius: 4px;
  background-color: #ffffff;

  .ant-select-selection-placeholder {
    color: rgba(0, 0, 0, 0.5);
  }
  .ant-select-arrow {
    display: flex;
    justify-content: center;
    align-items: center;
    .triangle-down {
      width: 0;
      border-left: 5.5px solid transparent;
      border-right: 5.5px solid transparent;
      border-top: 7px solid #5a5a5a;
      height: 7px;
      display: block;
    }
  }
  .ant-select-selector {
    padding: 0 8px !important;
  }
`;
